module.exports = __webpack_public_path__ + "img/tn-timeline-misc-19.922b0bdb.jpg";